// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1O3Xc","title":"styles_title__3RhOe"};